import React from 'react';
import './JourneyTimeline.css';

const JourneyTimeline = () => {
  const timeline = [
    {
      year: '2003',
      milestone: 'The Beginning',
      description: 'Vantala Jangaiah Yadav starts his real estate journey as Admin Peon at Siri Nidhi Homes, learning the industry from ground up.',
      icon: '🌱'
    },
    {
      year: '2005-2010',
      milestone: 'Building Expertise',
      description: 'Decades of hands-on experience in DTCP and HMDA plot development. Parallel venture into Raising Motor Driving School.',
      icon: '📚'
    },
    {
      year: '2015',
      milestone: 'Swayam Homes Founded',
      description: 'With unwavering vision and customer trust, Swayam Homes Pvt Ltd is established. The journey of building communities begins.',
      icon: '🏗️'
    },
    {
      year: '2015-2020',
      milestone: 'Growth & Expansion',
      description: 'Successfully developed 800+ acres across premium locations. Delivered thousands of satisfied customers and thriving communities.',
      icon: '📈'
    },
    {
      year: '2020-2021',
      milestone: 'Pandemic Resilience',
      description: 'Maintained exceptional sales performance during challenging times, proving the strength of customer trust and brand credibility.',
      icon: '💪'
    },
    {
      year: '2023-2026',
      milestone: 'The Next Chapter',
      description: 'Expansion into high-rise apartments, luxury villas, and independent homes. Positioning as an all-rounder in real estate.',
      icon: '🚀'
    }
  ];

  return (
    <section className="journey-timeline">
      {/* Eyebrow */}
      <div className="timeline-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Our Journey</span>
        <div className="eyebrow-line"></div>
      </div>

      <h2 className="timeline-title">From 2003 to Today</h2>
      <p className="timeline-subtitle">The remarkable journey of Vantala Jangaiah Yadav and Swayam Homes</p>

      {/* Timeline */}
      <div className="timeline-container">
        <div className="timeline-line"></div>
        
        {timeline.map((item, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
            <div className="timeline-content">
              <div className="timeline-icon">{item.icon}</div>
              
              <div className="timeline-card">
                <div className="timeline-year">{item.year}</div>
                <h3 className="timeline-milestone">{item.milestone}</h3>
                <p className="timeline-description">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Legacy Statement */}
      <div className="legacy-statement">
        <p>
          From a humble beginning to industry leadership, Swayam Homes stands as a testament to vision, 
          dedication, and unwavering commitment to customer success. 
          Today, we continue to build legacies, not just homes.
        </p>
      </div>
    </section>
  );
};

export default JourneyTimeline;
